/**
 * @desc 推送库存占用
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.stockOccupy.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/stockOccupy`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
